export enum LeaderboardMetricTypesEnum {
	RSVPs = 'rsvps',
	Revenue = 'revenue'
}
